import { Observable } from 'rxjs';
import { Step } from '../../types';
import { Flow } from '@lx/quote-tool/lite/shared/types';

export interface StepResolverStrategy {
  resolve(activeFlow?: Flow): Observable<Step>;
}
